import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
import styles from "./Accordion.module.scss";
export const AccordionContext = createContext({
    expandedIds: [],
});
export const useAccordionContext = () => {
    const context = useContext(AccordionContext);
    if (!context) {
        throw new Error("Accordion compound components cannot be rendered outside the Accordion component");
    }
    return context;
};
export const Accordion = ({ singleExpanded = false, defaultExpanded = [], dispatchGTMEvent, children, }) => {
    const [expandedItems, setExpandedItems] = useState(defaultExpanded);
    const toggleAccordionItem = (id) => {
        setExpandedItems((prev) => {
            if (prev.includes(id)) {
                return prev.filter((item) => item !== id);
            }
            return singleExpanded ? [id] : [...prev, id];
        });
    };
    return (_jsx(AccordionContext.Provider, { value: { expandedIds: expandedItems, toggleAccordionItem, dispatchGTMEvent }, children: _jsx("div", { className: styles.accordionContainer, children: children }) }));
};
//# sourceMappingURL=Accordion.js.map